export class Pageable<T> {
  public Items: T[];

  public TotalRecords: number;
}

